// TODO: Reference text
/**
 * InfoBox
 */
import React from 'react';
import clsx from 'clsx';
import Tooltip from '../Tooltip';
import { Icon, ButtonSupportive } from 'ui-component-library/base';
import { useUuid } from 'ui-component-library/hooks';
/** An infobox for highlighting content. */
var InfoBox = function (_a) {
    var heading = _a.heading, tooltipText = _a.tooltipText, tooltipLabel = _a.tooltipLabel, children = _a.children, _b = _a.headingLevel, headingLevel = _b === void 0 ? 'h2' : _b, _c = _a.variant, variant = _c === void 0 ? 'default' : _c, copyToClipboardText = _a.copyToClipboardText;
    var Heading = headingLevel;
    var getUuid = useUuid()[0];
    var id = getUuid();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: variant !== 'unstyled' ? "infobox-" + id : '', "data-cid": "InfoBox", className: clsx('rounded', variant !== 'unstyled' && 'border-l-4', variant !== 'small' && 'p-8', variant !== 'references' &&
                variant !== 'small' &&
                variant !== 'unstyled' &&
                'bg-greyLighter', variant === 'references' &&
                'border-greyLight border-t border-r border-b pt-6', variant === 'warning' && 'border-red', variant === 'default' && 'border-infobox-border-color', variant === 'services' && 'border-magenta', variant === 'small' && 'px-4 border-teal', variant === 'unstyled' && 'border-4 border-greyLight') },
            copyToClipboardText && variant === 'unstyled' && (React.createElement("div", { className: "mb-4" },
                React.createElement(ButtonSupportive, { className: "clipboard", variant: "squared", "data-clipboard-target": "#infobox-" + id },
                    React.createElement(Icon, { icon: "copy", className: "mr-2 mb-1", "aria-hidden": true, color: "#00636A" }),
                    copyToClipboardText))),
            React.createElement("div", { id: variant === 'unstyled' ? "infobox-" + id : '' },
                React.createElement(Heading, { className: clsx(variant === 'references' &&
                        'mb-4 text-h3 font-bold leading-8 inline-block', variant === 'small' && 'mt-0 mb-2 text-h3 font-bold inline-block', variant !== 'references' &&
                        variant !== 'small' &&
                        'mt-0 mb-2 text-h3 font-bold inline-block') }, heading),
                tooltipText && tooltipLabel && (React.createElement(Tooltip, { label: tooltipLabel, description: tooltipText, className: "align-text-bottom" })),
                React.createElement("div", { className: clsx('richtext infobox', variant === 'references' && 'infobox--references') }, children))),
        copyToClipboardText && variant !== 'unstyled' && (React.createElement("div", { className: "flex flex-row-reverse mt-2" },
            React.createElement("button", { className: "clipboard text-teal text-p", "data-clipboard-target": "#infobox-" + id },
                React.createElement(Icon, { icon: "copy", size: 2, className: "mr-2 mb-1", "aria-hidden": true }),
                copyToClipboardText)))));
};
export default InfoBox;
